import { render, staticRenderFns } from "./supplierbalance_details.vue?vue&type=template&id=7daf5170"
import script from "./supplierbalance_details.vue?vue&type=script&lang=js"
export * from "./supplierbalance_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports